import styles from "./Containers.module.css";

const FullscreenCard = ({ children }) => {
  return <div className={styles.fullscreenCard}>{children}</div>;
};

export default FullscreenCard;
